"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorfulBrushShader = void 0;
/**
 * Copyright (c) 2024 BrightSpike
 * All rights reserved.
 *
 * This source code is unlicensed.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 *
 * For detailed license information, please contact Brightspike at (info@brightspike.io).
 * @author Austin Weidler
 */
const BrushShader_1 = require("./BrushShader");
const colorful_frag_1 = __importDefault(require("./glsl/colorful.frag"));
class ColorfulBrushShader extends BrushShader_1.BrushShader {
    constructor() {
        super(colorful_frag_1.default, {});
        this.ticker.speed = 1 / 180;
    }
}
exports.ColorfulBrushShader = ColorfulBrushShader;
